"use client";

import { DownloadStem } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/DownloadStem";
import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { SoftText } from "@/components/text/SoftText";
import { StemSplitWithAudioNoDates } from "@/types/defs/stemSplit";
import { getStemTypeDisplayName } from "@/utils/stemSplit/getStemTypeDisplayName";

export function DetailsStemSplit({
  stemSplit,
}: {
  stemSplit: StemSplitWithAudioNoDates;
}) {
  const audioUrl = stemSplit.outputSoundMp3.presignedUrlPlay;

  return (
    <li className="rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5">
      <div className="flex items-center gap-x-3">
        <BigAudioPlayer
          source={audioUrl}
          bigWaves={false}
          className="w-full"
          includePreviewText={false}
          filename={null}
        />

        <DownloadStem stemSplit={stemSplit} />
      </div>
      <div className="mt-2 flex justify-between gap-x-1">
        <SoftText elementType="p" className="truncate">
          {getStemTypeDisplayName(stemSplit.stemType)}
        </SoftText>
      </div>
    </li>
  );
}
